"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FileIsNotAnImageError = _interopRequireDefault(require("./FileIsNotAnImageError"));

var _FileExtensionIsNotSupportedError = _interopRequireDefault(require("./FileExtensionIsNotSupportedError"));

var _DropZoneErrorTypes = _interopRequireDefault(require("../../enums/DropZoneErrorTypes"));

var _default = function _default(props) {
  var type = props.type,
      rest = (0, _objectWithoutProperties2.default)(props, ["type"]);

  switch (type) {
    case _DropZoneErrorTypes.default.NOT_AN_IMAGE:
      return _react.default.createElement(_FileIsNotAnImageError.default, rest);

    case _DropZoneErrorTypes.default.INVALID_FILE_EXTENSION:
      return _react.default.createElement(_FileExtensionIsNotSupportedError.default, rest);

    default:
      return _react.default.createElement(_FormattedMessage.default, {
        message: "FileManagerLib.fileUploadError"
      });
  }
};

exports.default = _default;
module.exports = exports.default;